import React from "react";
import PropTypes from "prop-types";
import { ACCOUNTING, QUALITY_CONTROL } from "MODULES/users/constants";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import { hasAnyOfRoles } from "MODULES/users/helpers";
import NewNote from "./CreateNote/NewNote";

export default function HeaderTrace(props) {
  const currentUser = useCurrentUser();

  return (
    <div>
      <hr className="hr-dashed trace-header" />
      <h2>
        Trace Notes
        {hasAnyOfRoles(currentUser, [QUALITY_CONTROL, ACCOUNTING]) && (
          <NewNote {...props} trace />
        )}
      </h2>
    </div>
  );
}

HeaderTrace.propTypes = {
  trace: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/Notes/HeaderTrace.jsx